<template>
  <div>
    <!-- <h4>Download</h4> -->
    <!-- <p>{{ msg }}</p> -->
    <H4>NSS 评估下载</H4>
    <texts class="contener">
      <li>
        <a href="setup_newss_win_x64_teacher_v1.03.1206.exe"
          >下载蓝云天同窗电子教室 Windows 版评估安装包 教师版 </a
        ><br />(适合Intel/AMD/海光/兆芯CPU)
      </li>
      <li>
        <a href="setup_newss_win_x64_student_v1.03.1206.exe"
          >下载蓝云天同窗电子教室 Windows 版评估安装包 学生版 </a
        ><br />(适合Intel/AMD/海光/兆芯CPU)
      </li>
      <li>
        <a href="YCNss-linux-all-v1.0.8.zip"
          >下载云巢电子教室国产OS版（Linux）安装包 </a
        ><br />（2022.3.23 适合Intel/AMD/海光/兆芯CPU)
      </li>
      <li>
        <a href="ycnss-linux-arm64-v1.0.0.deb"> 下载云巢电子教室国产OS飞腾版</a>
        <br />220401安装包（适合飞腾/鲲鹏CPU)
      </li>
      <li>
        <a href="cn.newcloud.newss_1.0.3.1197_arm64.deb"
          >下载蓝云天同窗电子教室 arm 版评估安装包 </a
        ><br />(教师端 适合飞腾/鲲鹏CPU)
      </li>
      <li>
        <a href="cn.newcloud.newssst_1.0.3.1197_arm64.deb"
          >下载蓝云天同窗电子教室 arm 版评估安装包 </a
        ><br />(学生端 适合飞腾/鲲鹏CPU)
      </li>
      <li>
        <a href="JS22001_蓝云天同窗信创版安装使用手册.pdf"
          >下载《蓝云天同窗信创版安装使用手册》 </a
        ><br />（2022.3.23修订）
      </li>
      <li>
        <a href="JS22002_蓝云天同窗信创版建设方案.pdf"
          >下载《蓝云天同窗信创版建设方案》 </a
        ><br />（2023.10.18修订）
      </li>
      <!-- <texts class="contener">
        (使用 Windows 版本的程序，请先
        <a href="https://developer.microsoft.com/zh-cn/microsoft-edge/webview2/"
          >安装 webview2 模块</a
        >，选择32位安装包下载安装。)
      </texts> -->
    </texts>
  </div>
</template>
<script>
export default {
  data() {
    return {
      msg: "下载",
    };
  },
};
</script>